export const DOCUMENT_SIGNATURE_DIALOG_ID = 'document-signature-dialog';
